import { render, staticRenderFns } from "./messagesView.vue?vue&type=template&id=3b9a7004&scoped=true&"
import script from "./messagesView.vue?vue&type=script&lang=js&"
export * from "./messagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a7004",
  null
  
)

export default component.exports